



















import { Vue, Component } from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Accordion from '@/components/Accordion.vue';
import Loader from '@/components/Loader.vue';

import { State } from '@/store/disbursement';

import { mapState } from 'vuex';

import { User } from '@/libs/api.interfaces';
import BalanceBox from './BalanceBox.vue';

@Component({
  components: {
    LayoutContent,
    Button,
    Loader,
    BalanceBox,
    Accordion,
  },
  computed: mapState(['disbursement', 'user']),
})
export default class BalanceJumbotron extends Vue {
  disbursement!: State;
  user!: {
    user: User;
  };
}
